import React, { useEffect } from "react";


export const WeekCheckAct = () => {
    useEffect(() => {
        $(".btns-checked-act ul li a").click(function () {
            $(this).toggleClass("on");
        });
    }, []);

    return (
        <div className="week btns-checked-act">
            <ul>
                <li><a>일</a></li>
                <li><a>월</a></li>
                <li><a>화</a></li>
                <li><a>수</a></li>
                <li><a>목</a></li>
                <li><a>금</a></li>
                <li><a>토</a></li>
            </ul>
        </div>
    );
};
